import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { captableUrl } from 'common/config/urls';
import { EMPTY_COLUMNS } from 'common/constants/cap-table';
import { MessageBox } from 'components';
import GoToCapTable from '../GoToCapTable';
import { EmptyCapTableMessageProps } from './EmptyCapTableMessage.props';

const EmptyCapTableMessage = ({ title, tagline, secondaryAction }: EmptyCapTableMessageProps) => {
  const { firmSlugParam, companySlugParam } = useParams<{ firmSlugParam: string; companySlugParam: string }>();

  const capTableURL = useMemo(() => captableUrl(firmSlugParam, companySlugParam), [firmSlugParam, companySlugParam]);

  return (
    <MessageBox
      title={title || EMPTY_COLUMNS({ tableName: 'Cap Table', columnName: 'Securities' })}
      tagline={tagline || 'Please add a valid Security first'}
      fullWidth={false}
      action={<GoToCapTable capTableURL={capTableURL} />}
      secondaryAction={secondaryAction}
    />
  );
};

export default EmptyCapTableMessage;
